import joi from 'joi';

import { attributeFiltersSchema } from '../../../attributeFilters';
import type { PartialRequireAtLeastOne } from '../../../types';
import { identity } from '../../../utils/functions';
import type { PolicyWithAttributeScopes } from '../../PolicyWithAttributeScopes';

type PolicyWithAttributeScopesRequestBodyBase = Omit<
  PolicyWithAttributeScopes,
  'id' | 'isSystem' | 'scopeType'
>;

const policyWithAttributeScopesRequestBodyBaseSchema = joi.object().keys(
  identity<joi.SchemaMap<PolicyWithAttributeScopesRequestBodyBase>>({
    name: joi.string().required(),
    description: joi.string().allow('').required(),
    attributeFilters: attributeFiltersSchema.required(),
  }),
);

// POST /policies/scopes/attributes
export type PoliciesWithAttributeScopesPostRequestBody =
  PolicyWithAttributeScopesRequestBodyBase;
export const policiesWithAttributeScopesPostRequestBodySchema =
  policyWithAttributeScopesRequestBodyBaseSchema;
export type PoliciesWithAttributeScopesPostResponseBody =
  PolicyWithAttributeScopes;

// GET /policies/scopes/attributes/:policyKey
export type PolicyWithAttributeScopesGetResponseBody =
  PolicyWithAttributeScopes;

// PATCH /policies/scopes/attributes/:policyKey
export type PolicyWithAttributeScopesPatchRequestBody =
  PartialRequireAtLeastOne<PolicyWithAttributeScopesRequestBodyBase>;
export const policyWithAttributeScopesPatchRequestBodySchema =
  policyWithAttributeScopesRequestBodyBaseSchema
    .fork(['attributeFilters', 'description', 'name'], (e) => e.optional())
    .min(1);
export type PolicyWithAttributeScopesPatchResponseBody =
  PolicyWithAttributeScopes;

// PUT /policies/scopes/attributes/:policyKey
export type PolicyWithAttributeScopesPutRequestBody =
  PolicyWithAttributeScopesRequestBodyBase;
export const policyWithAttributeScopesPutRequestBodySchema =
  policyWithAttributeScopesRequestBodyBaseSchema;
export type PolicyWithAttributeScopesPutResponseBody =
  PolicyWithAttributeScopes;
